import React from "react"

import { useShopify } from "../../hooks/useShopify"

export const withShopifyImage = Component => ({ name = "ShopifyImage", ...props }) => {
  const { imageUrl, imageSrcSets } = useShopify()

  Component.displayName = name
  return <Component {...props} imageUrl={imageUrl} imageSrcSets={imageSrcSets} />
}
